import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) { setError(res.error); return; }
    toast.success("Bienvenido");
    const next = res.user.onboarded ? "/dashboard" : "/onboarding";
    navigate(next);
  };

  return (
    <div className="bg-[#F9F9F8] min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          <div className="eyebrow mb-3">Ingresar</div>
          <h1 className="font-display text-3xl font-bold text-gray-900 leading-tight">Hola de nuevo.</h1>
          <p className="mt-2 text-sm text-gray-600">¿No tienes cuenta? <Link to="/register" data-testid="login-link-register" className="underline">Crear cuenta</Link></p>

          <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <label className="eyebrow block mb-2">Email</label>
              <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 outline-none focus:ring-2 focus:ring-[#0B2447] focus:border-transparent" />
            </div>
            <div>
              <label className="eyebrow block mb-2">Contraseña</label>
              <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 outline-none focus:ring-2 focus:ring-[#0B2447] focus:border-transparent" />
            </div>
            {error && <div className="text-sm text-red-600 border border-red-200 bg-red-50 p-3" data-testid="login-error">{error}</div>}
            <button data-testid="login-submit" disabled={loading} type="submit"
              className="w-full bg-[#0B2447] hover:bg-[#071932] text-white font-semibold py-3 flex items-center justify-center gap-2 transition-transform hover:-translate-y-0.5 disabled:opacity-60">
              {loading ? "Ingresando..." : "Ingresar"} <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
      <div className="hidden lg:block flex-1 bg-[#0A0A0A] relative">
        <div className="absolute inset-0 bg-grid-dark opacity-30" />
        <div className="absolute inset-0 flex items-center justify-center px-12">
          <div className="text-white max-w-md">
            <div className="eyebrow text-gray-400 mb-3">Ley 21.719 — Derechos ARCOP</div>
            <h2 className="font-display text-4xl font-bold leading-tight">
              Acceso, Rectificación, Cancelación, Oposición y Portabilidad.
            </h2>
            <p className="mt-6 text-gray-400 leading-relaxed">
              Cinco derechos consagrados en la nueva ley chilena de datos personales. borra-me.com los ejerce por ti.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
